var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.574 7.222a1.925 1.925 0 0 0-1.926 1.925v3.64h7.276v-3.64A1.925 1.925 0 0 0 18 7.222h-3.425Zm8.35 5.564v-3.64A4.925 4.925 0 0 0 18 4.223h-3.425a4.925 4.925 0 0 0-4.926 4.925v3.64H6.223v14.991h20.13V12.786h-3.429Zm-13.701 3v8.992h14.13v-8.992H9.222Zm5.562 7.065v-5.137h3v5.137h-3Z",
    fill: "currentColor"
  })));
};
export default SvgLock;